import { JSX, useMemo } from "react";
import { useTranslation } from "react-i18next";

import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { ChartEntry } from "./PieChartView";

export type LegendViewProps = {
	data: Array<ChartEntry>;
};

export default function LegendView(
	props: Readonly<LegendViewProps>
): JSX.Element {
	const { t } = useTranslation();

	const total = useMemo(
		() => props.data.reduce((a, b) => a + b.value, 0),
		[props.data]
	);

	return (
		<Table size="small">
			<TableHead>
				<TableRow>
					<TableCell padding="none"></TableCell>
					<TableCell>{t("score")}</TableCell>
					<TableCell>#</TableCell>
					<TableCell>%</TableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{props.data.map(entry => (
					<TableRow key={entry.label}>
						<TableCell padding="none">
							<Box
								sx={{
									width: 20,
									height: 20,
									border: "1px solid black",
									backgroundColor: entry.colour
								}}
							/>
						</TableCell>
						<TableCell>{entry.label}</TableCell>
						<TableCell>{entry.value}</TableCell>
						<TableCell>
							{((entry.value / total) * 100).toFixed(0)}
						</TableCell>
					</TableRow>
				))}
			</TableBody>
		</Table>
	);
}
